export class MaintenanceError extends Error {
  message =
    'We are currently doing maintenance on our server. It will be back soon.';
}
